if (!customElements.get('product-highlight')) {
  customElements.define(
    'product-highlight',
    class ProductHighlight extends HTMLElement {
      constructor() {
        super();
        this.inputs = this.querySelectorAll('[name="product-highlight"]');
        this.elementsToChange = this.querySelectorAll('[data-product]');

        this.inputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            this.toggleProduct(event.target.value);
          });
        });
      }

      connectedCallback() {
        // this could be used to set a default product highlight
        // this.inputs.forEach((input) => {
        //   console.log('input: ', input.checked);
        //   if (input.checked) {
        //     this.toggleProduct(input.value);
        //   }
        // });
      }

      toggleProduct(id) {
        this.elementsToChange.forEach((element) => {
          element.classList.add('hidden');
        });
        this.querySelectorAll(`[data-product="${id}"]`).forEach((element) => {
          element.classList.remove('hidden');
        });
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  let mySwiper = null;
  function initSwiper() {
    if (window.innerWidth <= 768) {
      if (!mySwiper) {
        mySwiper = new Swiper('.product_highlight_slider', {
          slidesPerView: 2,
          spaceBetween: 16,
          a11y: false,   
          breakpoints: {
            375: {
              slidesPerView: 3,
            },
          },
        });
      }
    } else {
      if (mySwiper) {
        mySwiper.destroy();
        mySwiper = null;
      }
    }
  }
  window.addEventListener('load', initSwiper);
  window.addEventListener('resize', initSwiper);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      if (mySwiper) {
        mySwiper.destroy();
        mySwiper = null;
      }
      initSwiper();
    });
  }
});
